<template>
  <div class="editBox">
    <div class="editBoxHeader">{{label}}
    <button v-if="!btnHide" class="closeBtn" @click="$emit('edit')">
      <iconEdit v-if="icon==='edit'" color="var(--color-pri)" color2="#FFFFFF" :width="32" :height="32"/>
      <iconSave v-if="icon==='save'" color="var(--color-pri)" color2="#FFFFFF" :width="32" :height="32"/>
    </button>
    </div>
    <div class="editBoxContent">
      <slot/>
    </div>
  </div>
</template>

<script>
import iconEdit from '../SVG/iconEdit'
import iconSave from '../SVG/iconSave'
export default {
  components: {
    iconEdit,
    iconSave
  },
  props: {
    icon: {
      type: String,
      default: 'edit'
    },
    btnHide: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.editBox {
  border: 1px solid var(--color-pri);
  width: 100%;
  min-height: 110px;
  height: fit-content;
  border-radius: 10px;
  position: relative;
  display: grid;
  grid-template-rows: 45px 1fr;
  grid-template-columns: 100%;
  min-height: fit-content;
}
.editBoxHeader {
  width: 100%;
  height: 45px;
  background-color: var(--color-pri);
  border-radius: 10px 10px 0 0;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 29px;
  letter-spacing: 0.1em;
  box-sizing: border-box;
  color: #FFFFFF;
  padding-inline: 28px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.closeBtn {
  position: absolute;
  right: 16px;
  top: 6px;
  margin: 0;
  padding: 0;
  width: 32px;
  height: 32px;
  border: none;
  background-color: transparent;
}
.editBoxContent {
  padding-block: 16px;
  padding-inline: 22px;
}
</style>
